import React, { useEffect, useState } from 'react'; 
import Sidebar from './Sidebar'; 
import styles from './../../Assets/CSS/Style.module.css';
import { SmButton } from './../../Components/Button';
import axios from 'axios';
import { BASE_URL } from './../../Environment';
import { toast } from 'react-toastify';
import Info from './Info';
 
function MarketFeedback() {
    const accessToken = localStorage.getItem('accessToken');
    useEffect(() => {
        document.title = 'Infomart | Client Market Feedback';
    }, []); 
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState(''); 
    const [isFeedbackLoading, setIsFeedbackLoading] = useState(false);
    const handleFeedback = async () => {
        setIsFeedbackLoading(true);
        await axios.post(`${BASE_URL}/vendor/market-feedback`, { subject, message }, {
            headers: {    
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        }).then((res) => { 
            setSubject('');
            setMessage(''); 
            toast.success(res.data.msg, { autoClose: 3000 });
            setIsFeedbackLoading(false);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsFeedbackLoading(false);
        });
    }  
    return (
        <div className="app"> 
            <div className="outlet">
                <Info />
                <div className="homeLayout">
                    <Sidebar /> 
                    <div className={styles.contactUsPageContainer}>
                        <h4>Market Feedback</h4>
                        <div className={styles.contactUsMain} style={{ justifyContent: 'center' }}>
                            <div className={styles.contactUsRight}>
                                <div className={styles.feedbackForm}>
                                    <h5>Feedback Form</h5>
                                    <div className={styles.inputContainer}>
                                        <input type="text" value={subject} placeholder="Subject" onChange={e => setSubject(e.target.value)} />
                                    </div>
                                    <textarea value={message} placeholder="Message" onChange={e => setMessage(e.target.value)} />
                                    <SmButton title={isFeedbackLoading ? "Loading..." : "Submit"} onClick={() => handleFeedback()} />
                                </div> 
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    );
}

export default MarketFeedback;        